import { Text, Flex, Icon } from 'dash-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { CardContainer } from 'pages/ProfilePage/components/ProfileBilling/ProfileBilling.styles';

function EmptyPaymentMethodsContainer() {
  const theme = useTheme();
  const { t: billingPageLabels } = useTranslation('pages', {
    keyPrefix: 'profilePage.billing',
  });

  return (
    <CardContainer p={4} mt={4} bgColor={theme.colors.b10}>
      <Flex>
        <Icon name="creditCard" mr={2} mt={1} color={theme.colors.n80} />
        <Flex flex={1}>
          <Text color={theme.colors.n80}>
            {billingPageLabels('emptyPaymentMethodsText')}
          </Text>
        </Flex>
      </Flex>
    </CardContainer>
  );
}

export default EmptyPaymentMethodsContainer;
